import View from './view';
export const UserCard = View;
